import React, {useEffect, useState} from "react";
import apiClient from "../axios/axiosInterceptor";
import SttServiceProviderSearch from "./SttServiceProviderSearch";
import SttServiceProviderTable from "./SttServiceProviderTable";
import '../modal.scss';
import SttServiceProviderCreate from "./SttServiceProviderCreate";
import {Slide, toast} from "react-toastify";

function SttServiceProviders() {
    const [providers, setProviders] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [editingProvider, setEditingProvider] = useState(null);

    const fetchProviders = async (name) => {
        const baseUrl = `/sttServiceProviders`;

        try {
            const response = await apiClient.get(baseUrl);
            if (!name) {
                setProviders(response.data.list);
                return;
            }
            const filteredProviders = response.data.list.filter(provider =>
                provider.name.toLowerCase().includes(name.toLowerCase())
            );
            setProviders(filteredProviders);
        } catch (error) {
            console.error('Error fetching providers:', error);
        }
    };

    useEffect(() => {
        fetchProviders();
    }, []);

    const search = async (name) => {
        await fetchProviders(name);
    };

    const handleCreate = () => {
        setEditingProvider(null);
        setShowModal(true);
    };

    const handleEdit = (provider) => {
        setEditingProvider(provider);
        setShowModal(true);
    };

    const handleDelete = async (id) => {
        const url = `/sttServiceProviders/${id}`;

        try {
            await apiClient.delete(url);
            await fetchProviders();
        } catch (error) {
            console.error('Error deleting provider:', error);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    const handleSubmitModal = async (providerData) => {
        const url = editingProvider ?
            `/sttServiceProviders/${editingProvider.id}` :
            `/sttServiceProviders`;

        try {
            if (editingProvider) {
                await apiClient.patch(url, providerData);
                toast.success('STT Service Provider updated!', {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            } else {
                await apiClient.post(url, providerData);
                toast.success('STT Service Provider created!', {
                    position: "top-right",
                    autoClose: 3000,
                    closeOnClick: false,
                    theme: "dark",
                    transition: Slide,
                });
            }
            setShowModal(false);
            await fetchProviders();
        } catch (error) {
            console.error('Error saving provider:', error);
        }
    };

    return (
        <div className="mainBody">
            <SttServiceProviderSearch onSearch={search} onCreate={handleCreate}/>
            <SttServiceProviderTable providers={providers} onEdit={handleEdit} onDelete={handleDelete}/>
            {showModal && <SttServiceProviderCreate provider={editingProvider} onClose={handleCloseModal}
                                                    onSubmit={handleSubmitModal}/>}
        </div>
    );
}

export default SttServiceProviders;
